module.exports = __webpack_public_path__ + "img/bg-banner.a623f1bc.png";